export default __webpack_public_path__ + "124ecc65a1d5a33dc3c9722930c148aa.png";